import { render, staticRenderFns } from "./NotaEmbeddedLayoutDesktop.vue?vue&type=template&id=2d7ebfa5&scoped=true&"
import script from "./NotaEmbeddedLayoutDesktop.vue?vue&type=script&lang=js&"
export * from "./NotaEmbeddedLayoutDesktop.vue?vue&type=script&lang=js&"
import style0 from "./NotaEmbeddedLayoutDesktop.vue?vue&type=style&index=0&id=2d7ebfa5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d7ebfa5",
  null
  
)

export default component.exports